import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const withLoginUser = Com => {
  const WrappedComponent = ({ loginUser, loginReducer, ...otherProps }) => (
    <Com loginUser={loginUser} {...otherProps} loginReducer={loginReducer} />
  );

  WrappedComponent.displayName = `withLoginUser(${Com.displayName || Com.name || 'Component'})`;

  WrappedComponent.propTypes = {
    loginUser: PropTypes.object.isRequired,
    loginReducer: PropTypes.object,
  };

  WrappedComponent.defaultProps = {};

  const mapStateToProps = state => ({
    loginUser: state.loginReducer,
    loginReducer: state.loginReducer,
  });

  return connect(mapStateToProps)(WrappedComponent);
};

export default withLoginUser;
